export interface Case {
  id: number;
  title: string;
  client: string;
  location: string;
  description: string;
  products: string[];
  images: string[];
  coverIndex?: number; // Índice da imagem de capa (padrão: 0)
  highlight?: boolean;
}

export const cases: Case[] = [
  {
    id: 1,
    title: 'Statregi - Caruaru/PE',
    client: 'Statregi Contabilidade',
    location: 'Caruaru - PE',
    description: 'Projeto completo de mobiliário corporativo para o escritório de contabilidade Statregi em Caruaru. Fornecimento e montagem de cadeiras, mesas, estações de trabalho e mobiliários de aço para toda a equipe — do atendimento às salas administrativas.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/a180be64-img_9705.webp',
      '/media/projetos/ece437e4-img_9711.webp',
      '/media/projetos/ef4db0d5-img_9713.webp',
      '/media/projetos/0f43fb46-img_9714.webp',
      '/media/projetos/050e2c99-img_9715.webp',
      '/media/projetos/f623530e-img_9716.webp',
      '/media/projetos/278e6a4a-img_9717.webp',
      '/media/projetos/74089aaf-img_9720.webp',
      '/media/projetos/073d1e47-img_9723.webp',
      '/media/projetos/6c77b470-img_9724.webp',
      '/media/projetos/0d070410-img_9010.webp',
      '/media/projetos/23862a7a-img_9011.webp',
    ],
    highlight: true,
  },
  {
    id: 2,
    title: 'Clínica - Bonito/PE',
    client: 'Clínica',
    location: 'Bonito - PE',
    description: 'Projeto de mobiliário completo para clínica em Bonito - PE. Fornecimento e montagem de cadeiras, longarinas para sala de espera e mobiliários funcionais para consultórios e recepção.',
    products: ['Longarinas Frisokar', 'Cadeiras Frisokar', 'Mesas Marzo Vitorino'],
    images: [
      '/media/projetos/6cb5c545-3e4135a5-ac2f-46e3-9aef-3462737f73f7.webp',
      '/media/projetos/ffa1c208-15cd9e95-4866-4838-84dd-854cc0723c63.webp',
      '/media/projetos/b99524fe-6457d4bc-21dc-4840-b654-db09514dd920.webp',
      '/media/projetos/df93d4cb-dae09572-4552-4617-8085-ff6933e4f020.webp',
    ],
    highlight: false,
  },
  {
    id: 3,
    title: 'Escritório de Advocacia',
    client: 'Escritório de Advocacia',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário completo para escritório de advocacia em Caruaru - PE. Fornecimento e montagem de mesas executivas, cadeiras, estantes e mobiliários de aço para salas de atendimento e área administrativa.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Estantes W3'],
    images: [
      '/media/projetos/f35ec6af-img_8473.webp',
      '/media/projetos/55dc7fcb-img_8476.webp',
      '/media/projetos/5c46044d-img_8477.webp',
      '/media/projetos/29091cab-img_8482.webp',
      '/media/projetos/aa8238ea-img_8483.webp',
      '/media/projetos/7cd67391-img_1633.webp',
      '/media/projetos/0f1bbdaf-img_1634.webp',
      '/media/projetos/0048f600-img_1635.webp',
      '/media/projetos/4f91a48d-img_1636.webp',
      '/media/projetos/433870a4-img_1640.webp',
      '/media/projetos/cc39ca56-img_1639.webp',
      '/media/projetos/de768f1e-img_1638.webp',
    ],
    highlight: true,
  },
  {
    id: 4,
    title: 'Plenário Câmara de Vereadores - Santa Cruz do Capibaribe/PE',
    client: 'Câmara de Vereadores de Santa Cruz do Capibaribe',
    location: 'Santa Cruz do Capibaribe - PE',
    description: 'Projeto de mobiliário para o plenário da Câmara de Vereadores de Santa Cruz do Capibaribe. Fornecimento e montagem de cadeiras, mesas e mobiliários institucionais para o espaço legislativo municipal.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/51a02fcf-img_5217.webp',
      '/media/projetos/d7a91a74-img_5218.webp',
      '/media/projetos/35614055-img_5221.webp',
      '/media/projetos/0f81ec40-img_5225.webp',
      '/media/projetos/1a581be4-img_5226.webp',
      '/media/projetos/78899df0-img_5229.webp',
      '/media/projetos/d60a9175-img_5230.webp',
    ],
    highlight: true,
  },
  {
    id: 5,
    title: 'Caruaru Shopping - Praça de Alimentação',
    client: 'Caruaru Shopping',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para a praça de alimentação do Caruaru Shopping. Fornecimento e montagem de mesas, cadeiras e mobiliários para o espaço de alimentação, proporcionando conforto e funcionalidade para os clientes do shopping.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Mobiliário para Food Court'],
    images: [
      '/media/projetos/edd9cec9-img_4245.webp',
      '/media/projetos/eec8220d-img_4248.webp',
      '/media/projetos/e73b9971-img_4251.webp',
      '/media/projetos/b3012d58-img_4254.webp',
      '/media/projetos/ba833b0f-img_4260.webp',
      '/media/projetos/300566bb-img_4266.webp',
      '/media/projetos/ca817be6-img_4279.webp',
    ],
    highlight: true,
  },
  {
    id: 6,
    title: 'Recepção Epic Tower',
    client: 'Epic Tower',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para a recepção do Epic Tower. Fornecimento e montagem de cadeiras, mesas e mobiliários para o espaço de recepção, garantindo elegância e funcionalidade para o ambiente corporativo.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Mobiliário para Recepção'],
    images: [
      '/media/projetos/954dc53d-img_3737.webp',
      '/media/projetos/71c15f0c-img_3738.webp',
      '/media/projetos/c1da72a2-img_3741.webp',
    ],
    highlight: false,
  },
  {
    id: 7,
    title: 'Instituto Vida - Garanhuns/PE',
    client: 'Instituto Vida',
    location: 'Garanhuns - PE',
    description: 'Projeto completo de mobiliário para o Instituto Vida em Garanhuns. Fornecimento e montagem de cadeiras, mesas, estações de trabalho e mobiliários para salas de atendimento, recepção e áreas administrativas.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/25cfc2ae-img_0967.webp',
      '/media/projetos/4c7fae1b-img_0969.webp',
      '/media/projetos/90638c88-img_0970.webp',
      '/media/projetos/1e66623d-img_0977.webp',
      '/media/projetos/968cec05-img_0980.webp',
      '/media/projetos/e8d0a180-img_0983.webp',
      '/media/projetos/8bafdea0-img_0984.webp',
      '/media/projetos/a9535439-img_0988.webp',
      '/media/projetos/1774ed3f-img_5199.webp',
    ],
    highlight: true,
  },
  {
    id: 8,
    title: 'Plenário Câmara de Vereadores - Ouricuri/PE',
    client: 'Câmara de Vereadores de Ouricuri',
    location: 'Ouricuri - PE',
    description: 'Projeto de mobiliário para o plenário da Câmara de Vereadores de Ouricuri. Fornecimento e montagem de cadeiras, mesas e mobiliários institucionais para o espaço legislativo municipal.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/b69a938c-img_1397.webp',
      '/media/projetos/7f12208b-img_1399.webp',
      '/media/projetos/866c3be8-img_1400.webp',
      '/media/projetos/2d60eca2-img_1404.webp',
      '/media/projetos/58557379-img_1408.webp',
      '/media/projetos/bcfb39b1-img_1409.webp',
      '/media/projetos/29f1d7ed-img_1411.webp',
      '/media/projetos/62b12c85-img_1425.webp',
      '/media/projetos/2fd3e9cd-img_1428.webp',
      '/media/projetos/5e836c13-img_1429.webp',
    ],
    highlight: true,
  },
  {
    id: 9,
    title: 'Sede Copergás - Recife/PE',
    client: 'Copergás',
    location: 'Recife - PE',
    description: 'Projeto de mobiliário corporativo para a sede da Copergás em Recife. Fornecimento e montagem de cadeiras, mesas, estações de trabalho e mobiliários de aço para escritórios, salas de reunião e áreas administrativas da companhia.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/c535bae2-005a3323-2fe5-4f55-95c4-7d767307d9d1.webp',
      '/media/projetos/0c732dc9-2582dc98-2019-4e5d-a1c2-11c41cf9b52c.webp',
      '/media/projetos/f5d8909e-ab98b8b9-560f-4ad2-8faf-a06753e4c688.webp',
      '/media/projetos/d7149284-b71bdf1f-478a-4cd9-9f26-b7733cd14ca4.webp',
      '/media/projetos/03eb1100-dsc_0026.webp',
      '/media/projetos/ba1164af-dsc_0123.webp',
      '/media/projetos/3662ab7f-dsc_0134.webp',
      '/media/projetos/0b5eee2e-dsc_0160.webp',
      '/media/projetos/661f8617-e18051f2-a140-48b1-a02f-e2cf84bb7470.webp',
      '/media/projetos/7d79ddfc-img_7245.webp',
    ],
    highlight: true,
  },
  {
    id: 10,
    title: 'Secretaria de Finanças - Paulista/PE',
    client: 'Secretaria de Finanças de Paulista',
    location: 'Paulista - PE',
    description: 'Projeto de mobiliário para a Secretaria de Finanças de Paulista, instalada em shopping. Fornecimento e montagem de mesas, cadeiras, estações de trabalho e mobiliários de aço para atendimento ao público e área administrativa.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/3fd111c1-img_4242.webp',
      '/media/projetos/ca8e058d-img_4246.webp',
      '/media/projetos/f6d6d35f-img_4249.webp',
      '/media/projetos/9705627e-img_4250.webp',
      '/media/projetos/8229b33a-img_4251.webp',
      '/media/projetos/720d5ff6-img_4253.webp',
      '/media/projetos/7f773b21-img_4255.webp',
      '/media/projetos/c2eaf28b-img_4258.webp',
      '/media/projetos/809d712d-img_4260.webp',
      '/media/projetos/afa71a7a-img_4263.webp',
    ],
    highlight: false,
  },
  {
    id: 11,
    title: 'Prefeitura de Água Preta - PE',
    client: 'Prefeitura Municipal de Água Preta',
    location: 'Água Preta - PE',
    description: 'Projeto de mobiliário para a Prefeitura Municipal de Água Preta. Fornecimento e montagem de mesas, cadeiras, estações de trabalho e mobiliários de aço para setores administrativos e de atendimento ao público.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/9cf1a3fd-img_6761.webp',
      '/media/projetos/60d1aa23-img_6763.webp',
      '/media/projetos/11eaba3f-img_6765.webp',
      '/media/projetos/149326cf-img_6767.webp',
      '/media/projetos/04e1d400-img_6770.webp',
      '/media/projetos/9e371307-img_6774.webp',
      '/media/projetos/73fecc49-img_6775.webp',
      '/media/projetos/0cc65c71-img_6776.webp',
      '/media/projetos/b10b89d0-img_6780.webp',
    ],
    highlight: true,
  },
  {
    id: 12,
    title: 'Banco Sicoob',
    client: 'Sicoob',
    location: 'Pernambuco',
    description: 'Projeto de mobiliário para agência do Banco Sicoob. Fornecimento e montagem de mesas, cadeiras, balcões de atendimento e mobiliários para área de autoatendimento e salas administrativas.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Mobiliário para Banco', 'Estantes W3'],
    images: [
      '/media/projetos/6a858509-17986c3c-1411-4fd8-b7ee-75622b38a065.webp',
      '/media/projetos/79a4b739-img_1279.webp',
      '/media/projetos/43bd97a5-img_1282.webp',
      '/media/projetos/dae53539-img_1286.webp',
      '/media/projetos/6ac8bfea-img_1288.webp',
      '/media/projetos/d526cf06-img_1300.webp',
      '/media/projetos/9823f9c4-img_1302.webp',
      '/media/projetos/b6fb3f7d-img_1303.webp',
      '/media/projetos/654256a6-img_1305.webp',
      '/media/projetos/947d29db-img_1310.webp',
    ],
    highlight: true,
  },
  {
    id: 13,
    title: 'Gabinete Especial - Prefeitura de Caruaru/PE',
    client: 'Prefeitura Municipal de Caruaru',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para o Gabinete Especial da Prefeitura de Caruaru. Fornecimento e montagem de mesas executivas, cadeiras, estantes e mobiliários de alto padrão para o espaço de representação institucional do município.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3', 'Estantes W3'],
    images: [
      '/media/projetos/ea3ae193-img_5096.webp',
      '/media/projetos/4c66372d-img_5092.webp',
      '/media/projetos/c56ddc19-img_5093.webp',
      '/media/projetos/90b09f71-img_5097.webp',
      '/media/projetos/ee1a3c39-img_5098.webp',
      '/media/projetos/89b44ffa-img_5099.webp',
      '/media/projetos/effd61a3-img_5103.webp',
    ],
    highlight: true,
  },
  {
    id: 14,
    title: 'Posto de Saúde - Petrolina/PE',
    client: 'Posto de Saúde de Petrolina',
    location: 'Petrolina - PE',
    description: 'Projeto de mobiliário para posto de saúde em Petrolina. Fornecimento e montagem de cadeiras, longarinas para sala de espera, mesas e mobiliários para consultórios, recepção e áreas administrativas.',
    products: ['Longarinas Frisokar', 'Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Armários W3'],
    images: [
      '/media/projetos/e1c658de-37bd96b2-f0a1-4f21-b0ae-96727242e271.webp',
      '/media/projetos/bf86c539-54f6bc7c-2c47-4529-b4e9-aa2c59ad8cf3.webp',
      '/media/projetos/ac4f93a7-93ba4249-8c1d-4dfa-b02f-12739ac4f88c.webp',
      '/media/projetos/6130a204-b1dad478-2424-4685-a10f-a2f6e6f9a46f.webp',
      '/media/projetos/e24a8a06-dfb10da4-6ab0-439f-908b-a066476df838.webp',
      '/media/projetos/55871e7e-e6ed11e5-1a98-4c23-b8af-422048015011.webp',
      '/media/projetos/cbeeafba-e63f5316-a85a-41d6-84d9-b5517c53f1ea.webp',
      '/media/projetos/f1bc08e6-ed9d762a-f9e2-444c-ab58-ae8833099bb8.webp',
    ],
    highlight: false,
  },
  {
    id: 15,
    title: 'Plenário Câmara de Vereadores - Vertentes/PE',
    client: 'Câmara de Vereadores de Vertentes',
    location: 'Vertentes - PE',
    description: 'Projeto de mobiliário para o plenário da Câmara de Vereadores de Vertentes. Fornecimento e montagem de cadeiras, mesas e mobiliários institucionais para o espaço legislativo municipal.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/7a85c746-3daa3710-8679-4c8e-97d2-b628eb0a6f31.webp',
      '/media/projetos/6ecb4313-8b5686a0-3092-4773-bf07-f22ee6ebffac.webp',
      '/media/projetos/7e8415ac-06330f4f-bebd-49bc-8784-d2a32b16cf3b.webp',
      '/media/projetos/7bd443af-65536e5c-921a-48d3-9c6a-c2e2636bb6ec.webp',
      '/media/projetos/69e54285-407580e9-8d5f-4b10-821d-3111e667785f.webp',
      '/media/projetos/0f20b927-e4eed097-7cde-4080-b022-4f7b47c9407f.webp',
      '/media/projetos/323630c8-ea1396e2-40f9-4013-b75e-9ede9e71ff02.webp',
    ],
    highlight: true,
  },
  {
    id: 16,
    title: 'Gabinete Prefeitura - Xexéu/PE',
    client: 'Prefeitura Municipal de Xexéu',
    location: 'Xexéu - PE',
    description: 'Projeto de mobiliário para o gabinete da Prefeitura de Xexéu. Fornecimento e montagem de mesas executivas, cadeiras e mobiliários de alto padrão para o espaço de representação institucional do município.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3'],
    images: [
      '/media/projetos/9551775c-9335ad2c-9e57-4008-bc85-bc73b1b1a8c6.webp',
      '/media/projetos/46df61a9-b45b5a78-795b-4468-8473-92e2310e0eec.webp',
      '/media/projetos/3bac5abf-edd977ec-e1b4-49bc-90db-05579a497652.webp',
    ],
    highlight: false,
  },
  {
    id: 17,
    title: 'Gabinete do Prefeito - Prefeitura de Caruaru/PE',
    client: 'Prefeitura Municipal de Caruaru',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário executivo para o Gabinete do Prefeito de Caruaru. Fornecimento e montagem de mesa de reunião institucional, cadeiras executivas de couro, armários baixos e mobiliário de alto padrão para o espaço de representação municipal, combinando elegância, funcionalidade e identidade institucional.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/640f4187-img_1561.webp',
      '/media/projetos/555fbee4-fed27aaa-27c3-4ec8-8cc1-11744d9578c0.webp',
      '/media/projetos/274b0821-5456e68e-c41d-483d-85b3-2e1bdf2e636b.webp',
    ],
    highlight: true,
  },
  {
    id: 18,
    title: 'Assembleia de Deus - Caruaru/PE',
    client: 'Assembleia de Deus',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para o salão da Assembleia de Deus em Caruaru. Fornecimento e montagem de dezenas de cadeiras empilháveis para o espaço de cultos e eventos, garantindo conforto, durabilidade e organização para a comunidade.',
    products: ['Cadeiras Frisokar', 'Cadeiras para Igreja', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/87b498c0-e304641d-78d4-4862-949b-9ec3ac051cb0.webp',
    ],
    highlight: true,
  },
  {
    id: 19,
    title: 'Seu projeto aqui',
    client: 'Em breve',
    location: 'Pernambuco',
    description: 'Estamos sempre realizando novos projetos. Entre em contato e faça parte do nosso portfólio.',
    products: [],
    images: [],
  },
  {
    id: 20,
    title: 'Sala de Reuniões Especiais - Prefeitura de Caruaru/PE',
    client: 'Prefeitura Municipal de Caruaru',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para a Sala de Reuniões Especiais da Prefeitura de Caruaru. Fornecimento e montagem de mesas executivas, cadeiras de couro e mobiliário de alto padrão para reuniões institucionais e decisões estratégicas do município.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Armários W3', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/0e2d530d-img_1550.webp',
      '/media/projetos/7a8216b8-img_1551.webp',
      '/media/projetos/413aa30b-img_1632.webp',
    ],
    highlight: true,
  },
  {
    id: 21,
    title: 'Hotel Ibis - Caruaru/PE',
    client: 'Hotel Ibis',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para o Hotel Ibis em Caruaru. Fornecimento e montagem de cadeiras, mesas e mobiliário para o espaço de refeições e áreas de convivência do hotel, combinando resistência, praticidade e o padrão visual reconhecido da rede hoteleira.',
    products: ['Cadeiras Frisokar', 'Mesas Marzo Vitorino', 'Mobiliário para Hotelaria'],
    images: [
      '/media/projetos/e15f101e-img_0228.webp',
      '/media/projetos/4d577a77-img_0229.webp',
      '/media/projetos/3cd41d7c-img_0231.webp',
    ],
    highlight: true,
  },
  {
    id: 22,
    title: 'Sala de Reuniões RodoNorte - Caruaru/PE',
    client: 'RodoNorte Transporte e Turismo',
    location: 'Caruaru - PE',
    description: 'Projeto de mobiliário para a Sala de Reuniões da RodoNorte em Caruaru. Fornecimento e montagem de mesa executiva, cadeiras ergonômicas e mobiliário de alto padrão para o espaço de decisões estratégicas da principal transportadora da região, unindo sofisticação e funcionalidade corporativa.',
    products: ['Mesas Marzo Vitorino', 'Cadeiras Frisokar', 'Mobiliário Institucional'],
    images: [
      '/media/projetos/bac4fec8-img_2427.webp',
      '/media/projetos/46ee46ea-img_2428.webp',
      '/media/projetos/2695912d-img_2429.webp',
    ],
    highlight: true,
  },
];
